import type { EventBlock } from '../types/schedule';
import { CHARS } from '../constants/schedule';

/**
 * Merge overlapping event blocks per day.
 * Each event: { id, dateKey, startIndex, endIndex }
 */
export function mergeOverlappingEvents(events: EventBlock[]) {
  const byDay: { [key: string]: EventBlock[] } = {};

  events.forEach(function (e: EventBlock) {
    if (!byDay[e.dateKey]) byDay[e.dateKey] = [];
    byDay[e.dateKey].push({ ...e });
  });

  const merged: EventBlock[] = [];

  Object.keys(byDay).forEach(function (day) {
    const list = byDay[day].slice().sort(function (a, b) {
      return a.startIndex - b.startIndex;
    });
    if (!list.length) return;

    let cur = list[0];
    for (let i = 1; i < list.length; i++) {
      const nxt = list[i];
      if (nxt.startIndex <= cur.endIndex) {
        cur.endIndex = Math.max(cur.endIndex, nxt.endIndex);
      } else {
        merged.push(cur);
        cur = nxt;
      }
    }
    merged.push(cur);
  });

  return merged;
}

// Generate a random room ID
export const generateRoomId = () => {
  const chars = CHARS;
  let id = '';
  for (let i = 0; i < 8; i++)
    id += chars[Math.floor(Math.random() * chars.length)];
  return id;
};
